<template>
  <el-dialog
    :visible.sync="isShowDialog" class="dialog-square"
    :title="currentItem['itemName'+_lang]" center width="800px"
    :close-on-click-modal="false" @close="whenDialogClose">
    <div class="dialog-con df-l-c-fs w100p">
      <div class="dialog-ctr w100p">

        <div class="mydialog df-l-c-fs" slot="content">
          <div class="scroll-box w100p">
            
            <div class="combo-item w100p df" v-for="(x1,i1) in items" :key="i1" @click="selectFood(x1)">
              <div class="checkbox df-c-ct">
                <img
                  style="width:20px;height:20px;" mode="aspectFill"
                  :src="x1.select?iconCheckok:iconChecknull" />
              </div>
              <div class="f1">
                <div class="df-c-sb">
                  <div class="text w100p sls df-c-fs">
                    <div class="sls f1">{{x1['name'+_lang]}}</div>
                    <div class="price">X{{x1.countInOrder|tothousands}}</div>
                  </div>
                </div>
                <CartItemDetail :item="x1" :fontSize="14" />
              </div>
            </div>

          </div>

          <div class="btm w100p df-fe">
            <div :class="submitBtnOk?'themebtn':'whitebtn'" @click="dialogSubmit">{{$t('common.reminder')}}</div>
          </div>
        </div>
          
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'DialogReminder',
  data() {
    return {
      isShowDialog: false,
      
      currentItem: {},

      items: [],

      submitBtnOk: true,
    }
  },
  methods: {
    open(item) {
      this.currentItem = JSON.parse(JSON.stringify(item))
      // console.log(`%c是套餐-商品詳情:`, 'color: #f00;', this.currentItem, this.currentItem.setMenuOneItemList)

      this.items = []

      this.currentItem.setMenuOneItemList.forEach(x1 => {
        x1.itemList.forEach(x2 => {
          x2.select = true
          x2.pid = x1.id
          if (x2.countInOrder > 1) {
            for (let i = 0; i < x2.countInOrder; i++) {
              this.items.push({
                ...JSON.parse(JSON.stringify(x2)),
                countInOrder: 1,
              })
            }
          } else {
            this.items.push(JSON.parse(JSON.stringify(x2)))
          }
        })
      })

      this.scan_canLeave_x_save(false)
      this.isShowDialog = true
    },
    close() {
      this.isShowDialog = false
    },
    whenDialogClose() {
      this.scan_canLeave_x_save(true)
      this.isShowDialog = false
      this.currentItem = {}
      this.items = []
    },

    // 选择菜品
    selectFood(item) {
      item.select = !item.select
      this.submitBtnOk = this.items.filter(x1 => x1.select).length > 0
    },

    dialogSubmit() {
      if (this.submitBtnOk) {
        this.$emit('submit', this.items.filter(x1 => x1.select).map(x1 => ({
          id: x1.id,
          pid: x1.pid,
          countInOrder: x1.countInOrder,
          itemDetailList: x1.itemDetailList,
        }))
      )
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/util_dialog.scss';
.mydialog{
  padding: 20px;

  .scroll-box{
    height: 380px;overflow: hidden scroll;
    .combo-item{
      border-bottom: 1px solid #DFDFDF;padding: 10px 0;
      // &:last-child{border-bottom: 0;}
      .checkbox{width: 36px;height: 36px;}
      .text{line-height: 36px;}
      .num{width: 60px;margin: 0 60px 0 20px;}
      .price{min-width: 180px;text-align: right;}

    }
  }
  .btm{padding: 20px 0 10px;}
}
</style>